import {RouterProps} from "../../RouterProps";
import {Route, Routes} from "react-router-dom";
import List from "./List";
import Detail from "./Detail";
import ReasonRouter from "./reason/ReasonRouter";

export default function WithdrawalRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:userWithdrawalId'} element={<Detail {...props} />} />
            <Route path={'/reasons/*'} element={<ReasonRouter {...props} />} />
        </Routes>
    </>
}